import { FetchOptions } from 'bernie-core';
import {
  FlightsQueryState,
  FlightsShoppingPwaFlightSearchResultsFlightsSearch,
  flightsShoppingPwaFlightSearchResultsFlightsSearchQuery
} from '__generated__/api/';

export function clientInfoHeader(headers, appName, region): Headers {
  return {
    ...headers,
    'Client-Info': `${appName},latest,${region || 'external'}`
  };
}

export const getFlightsSearchLoadedHeaders = (
  options: FetchOptions,
  variables: FlightsShoppingPwaFlightSearchResultsFlightsSearch.Variables,
  appName: string,
  region: string,
  pageId: string
): RequestInit => {
  const {
    headers: { connection },
    context: { deviceId }
  } = options.request;

  const flightsSearchLoadedHeaders = {
    'Content-Type': 'application/json',
    credentials: 'same-origin',
    Connection: connection,
    'Device-User-Agent-ID': deviceId,
    'x-page-id': pageId
  };

  const headers = clientInfoHeader(flightsSearchLoadedHeaders, appName, region);

  const reqBody = {
    operationName: 'FlightsShoppingPwaFlightSearchResultsFlightsSearch',
    query: flightsShoppingPwaFlightSearchResultsFlightsSearchQuery,
    variables: {
      ...variables,
      queryState: FlightsQueryState.LOADED
    }
  };

  return {
    method: 'POST',
    headers,
    cache: 'no-cache',
    body: JSON.stringify(reqBody)
  };
};
